export default __webpack_public_path__ + "static/media/07_YEARNING.1543c468.png";